import { FaGlobeAmericas, FaClock, FaMoneyBillWave, FaCalendarAlt } from "react-icons/fa";
import SearchableSelect from "modules/swiftboard/components/ui/SearchableSelect";
import { SectionShell, DATE_FORMATS, TIME_FORMATS } from "./settings-shared";

export default function RegionalSection({ formData, onChange, timezones, currencies, loadingOptions }) {
  const timezoneOptions = timezones.map((tz) => ({
    value: tz.id,
    label: `${tz.display_name || tz.iana_name}${tz.utc_offset ? ` (${tz.utc_offset})` : ""}`,
  }));

  const currencyOptions = currencies.map((c) => ({
    value: c.id,
    label: `${c.code} — ${c.name}`,
  }));

  const dateFormatOptions = DATE_FORMATS.map((f) => ({ value: f, label: f }));

  return (
    <SectionShell id="regional" icon={FaGlobeAmericas} title="Regional & Language" subtitle="Timezone, currency and date formatting">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-medium text-text_secondary mb-1.5 flex items-center gap-1.5">
            <FaClock size={11} className="text-text_muted shrink-0" />
            Timezone
          </label>
          <SearchableSelect
            options={timezoneOptions}
            value={formData.timezone_fid}
            onChange={(val) => onChange("timezone_fid", val)}
            placeholder="Select timezone"
            isDisabled={loadingOptions}
            isLoading={loadingOptions}
            isClearable
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-text_secondary mb-1.5 flex items-center gap-1.5">
            <FaMoneyBillWave size={11} className="text-text_muted shrink-0" />
            Currency
          </label>
          <SearchableSelect
            options={currencyOptions}
            value={formData.currency_fid}
            onChange={(val) => onChange("currency_fid", val)}
            placeholder="Select currency"
            isDisabled={loadingOptions}
            isLoading={loadingOptions}
            isClearable
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-text_secondary mb-1.5 flex items-center gap-1.5">
            <FaCalendarAlt size={11} className="text-text_muted shrink-0" />
            Date Format
          </label>
          <SearchableSelect
            options={dateFormatOptions}
            value={formData.date_format}
            onChange={(val) => onChange("date_format", val || DATE_FORMATS[0])}
            placeholder="Select date format"
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-text_secondary mb-1.5 flex items-center gap-1.5">
            <FaClock size={11} className="text-text_muted shrink-0" />
            Time Format
          </label>
          <SearchableSelect
            options={TIME_FORMATS}
            value={formData.time_format}
            onChange={(val) => onChange("time_format", val || TIME_FORMATS[0].value)}
            placeholder="Select time format"
          />
        </div>
      </div>
    </SectionShell>
  );
}
